import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Tag } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledProductCoupon = styled.div`
  display: flex;
  justify-content: space-between;
`;
const CouponCode = styled.div``;
const CouponDiscount = styled.div((props) => `
    display: flex;
    flex-direction: ${props.reverse ? "column-reverse" : "column"};
    text-align: right;
    margin-left: 0.5rem;
  `);
const Text = styled.div`
  font-size: 11px;
`;
const Highlight = styled.div(({ theme }) => `
  font-size: 0.9rem;
  font-weight: 500;
  color: ${theme == null ? void 0 : theme.colors.red}
  `);
const ProductCoupon = ({
  tag,
  detail,
  className
}) => /* @__PURE__ */ React.createElement(StyledProductCoupon, {
  className
}, /* @__PURE__ */ React.createElement(CouponCode, null, /* @__PURE__ */ React.createElement(Text, null, t("Nh\u1EADp m\xE3")), /* @__PURE__ */ React.createElement(Tag, __spreadValues({}, tag))), /* @__PURE__ */ React.createElement(CouponDiscount, {
  reverse: detail.reverse
}, /* @__PURE__ */ React.createElement(Text, null, detail.text), /* @__PURE__ */ React.createElement(Highlight, null, detail.highlight)));

export { ProductCoupon };
